import { BlocksIconWarningTriangle } from 'blocks-nextjs/blocks-web-components/components/icon/icons/warning-triangle';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconWarningTriangle = createComponent({
  react: React,
  tagName: 'cat-icon-warning-triangle',
  elementClass: BlocksIconWarningTriangle
});
